export var JobStatus;
(function (JobStatus) {
    JobStatus["JOB_UNSPECIFIED"] = "JOB_UNSPECIFIED";
    JobStatus["JOB_PENDING"] = "JOB_PENDING";
    JobStatus["JOB_RUNNING"] = "JOB_RUNNING";
    JobStatus["JOB_COMPLETED"] = "JOB_COMPLETED";
    JobStatus["JOB_FAILED"] = "JOB_FAILED";
    JobStatus["JOB_PARTIAL"] = "JOB_PARTIAL";
    JobStatus["JOB_CANCELED"] = "JOB_CANCELED";
    JobStatus["JOB_RESULT_READY"] = "JOB_RESULT_READY";
})(JobStatus || (JobStatus = {}));
